import React, { Component } from 'react';
import AwardsComponent from './../components/awards';
// import * as api from '../api'

export default class OuterNoAward extends Component {
  constructor(props) {
    super (props)
    this.state = {
      isShow: false,
      awardsDom: null
    }
  }

  componentWillMount() {
    if (sessionStorage.getItem('yqs_curGame_awardInfo')) {
      let info = JSON.parse(sessionStorage.getItem('yqs_curGame_awardInfo'))
      this.setState({awardsDom: <AwardsComponent rateVal={info.globalfight}/>})
    } else {
      this.setState({awardsDom: <AwardsComponent rateVal={''}/>})
    }
  }

  _handle2JRApp() {
    window.location.href = `https://m.jr.jd.com/spe/downloadApp/index.html?id=1192&activityid=1158`
  }

  render() {
    return (
      <div className='main_info'>
        {this.state.awardsDom}
        <div className='award_info'>
          <p className='tipStr'>哎呀，红包溜走啦</p>
          <p className='tipStr'>更多活动尽在京东金融APP</p>
        </div>
        <div className='btn yellow' onClick={this._handle2JRApp.bind(this)} clstag="jr|keycount|yqsbhby|25">去京东金融APP看看</div>
      </div>
    )
  }
}